export default {
    // Header Section
    "discover_your": "Discover Your",
    "year_analysis": "Year Analysis",
    "yearly_cosmic_insights": "Yearly Cosmic Insights",
    "year_analysis_description": "Get comprehensive yearly analysis based on Vedic astrology and numerology. Understand your year's themes, monthly predictions, auspicious periods, challenges, and personalized guidance for success throughout the year.",

    "know_your": "Know Your",

    // Service Information
    "enter_details_for_year_analysis": "Enter Your Details for Year Analysis",
    "complete_year_analysis": "Complete Year Analysis",
    "service_price": "Service Price",
    "comprehensive_year_analysis_note": "Detailed yearly forecast with monthly predictions and timing guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_yearly_influence": "Your name influences yearly vibrations and annual cycles",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_yearly_cycles": "Essential for calculating personal year cycles and annual predictions",
    "analysis_year": "Analysis Year",
    "year_2024": "2024",
    "year_2025": "2025",
    "year_2026": "2026",
    "select_year_for_analysis": "Select the year you want detailed analysis for",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your year analysis will be delivered in the selected language",

    // Core Year Features
    "complete_yearly_forecast": "Complete Yearly Forecast",
    "monthly_breakdown_analysis": "Monthly Breakdown Analysis",
    "major_life_events_timing": "Major Life Events Timing",
    "favorable_unfavorable_periods": "Favorable & Unfavorable Periods",
    "yearly_remedies_guidance": "Yearly Remedies & Guidance",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Year Analysis Includes",
    "comprehensive_yearly_roadmap": "Comprehensive Yearly Roadmap",
    "month_by_month_predictions": "Month-by-Month Predictions",
    "auspicious_timing_guide": "Auspicious Timing Guide",
    "yearly_remedial_solutions": "Yearly Remedial Solutions",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Year Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "year_analysis_processing": "Your comprehensive year analysis is being prepared by our expert astrologers. You'll receive detailed monthly predictions and yearly guidance.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_18_hours_delivery_note": "Your detailed year analysis will be ready within 18 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Year Analysis Package",
    "detailed_year_analysis": "Detailed Year Analysis Report (PDF)",
    "monthly_predictions_calendar": "Monthly Predictions Calendar",
    "auspicious_dates_timing": "Auspicious Dates & Timing",
    "yearly_remedies_guide": "Yearly Remedies Guide",
    "life_events_forecast": "Life Events Forecast",

    // Visual Content
    "sample_year_analysis": "Sample Year Analysis",
    "yearly_theme": "Yearly Theme",
    "sample_yearly_reading": "Growth and transformation with financial stability focus",
    "sample_year_preview": "Preview of your personalized year analysis with monthly insights",
    "monthly_overview": "Monthly Overview",

    // Month Abbreviations
    "jan": "Jan",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "Apr",
    "may": "May",
    "jun": "Jun",
    "jul": "Jul",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "Oct",
    "nov": "Nov",
    "dec": "Dec",

    // Status & Processing
    "your_year_analysis_status": "Your Year Analysis Status",
    "processing_your_analysis": "Analyzing Your Year",
    "analysis_processing_message": "Our expert astrologers are preparing your comprehensive year analysis with monthly predictions and timing guidance.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_18_hours": "Report ready within 18 hours",

    // Support & Contact
    "contact_support": "Contact Year Analysis Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Year-Specific Elements
    "personal_year_number": "Personal Year Number",
    "annual_theme": "Annual Theme",
    "year_vibration": "Year Vibration",
    "yearly_cycles": "Yearly Cycles",
    "annual_lessons": "Annual Lessons",
    "year_challenges": "Year Challenges",

    // Monthly Analysis
    "january_analysis": "January Analysis",
    "february_analysis": "February Analysis",
    "march_analysis": "March Analysis",
    "april_analysis": "April Analysis",
    "may_analysis": "May Analysis",
    "june_analysis": "June Analysis",
    "july_analysis": "July Analysis",
    "august_analysis": "August Analysis",
    "september_analysis": "September Analysis",
    "october_analysis": "October Analysis",
    "november_analysis": "November Analysis",
    "december_analysis": "December Analysis",

    // Quarterly Analysis
    "first_quarter": "First Quarter (Jan-Mar)",
    "second_quarter": "Second Quarter (Apr-Jun)",
    "third_quarter": "Third Quarter (Jul-Sep)",
    "fourth_quarter": "Fourth Quarter (Oct-Dec)",
    "quarterly_themes": "Quarterly Themes",
    "seasonal_influences": "Seasonal Influences",

    // Life Areas Yearly Focus
    "career_year_focus": "Career Year Focus",
    "love_relationships_year": "Love & Relationships Year",
    "health_wellness_year": "Health & Wellness Year",
    "financial_year_outlook": "Financial Year Outlook",
    "family_social_year": "Family & Social Year",
    "spiritual_growth_year": "Spiritual Growth Year",

    // Timing & Periods
    "peak_success_periods": "Peak Success Periods",
    "challenging_periods": "Challenging Periods",
    "neutral_periods": "Neutral Periods",
    "transformation_phases": "Transformation Phases",
    "opportunity_windows": "Opportunity Windows",
    "caution_periods": "Caution Periods",

    // Auspicious Timing
    "best_months_for_new_ventures": "Best Months for New Ventures",
    "favorable_travel_periods": "Favorable Travel Periods",
    "auspicious_wedding_dates": "Auspicious Wedding Dates",
    "good_investment_timing": "Good Investment Timing",
    "career_change_timing": "Career Change Timing",
    "property_purchase_timing": "Property Purchase Timing",

    // Annual Predictions
    "career_predictions": "Career Predictions",
    "business_forecast": "Business Forecast",
    "financial_outlook": "Financial Outlook",
    "relationship_predictions": "Relationship Predictions",
    "health_forecast": "Health Forecast",
    "family_predictions": "Family Predictions",

    // Success Factors
    "key_success_factors": "Key Success Factors",
    "growth_opportunities": "Growth Opportunities",
    "skill_development_focus": "Skill Development Focus",
    "networking_opportunities": "Networking Opportunities",
    "leadership_potential": "Leadership Potential",
    "creative_expression": "Creative Expression",

    // Challenges & Solutions
    "potential_obstacles": "Potential Obstacles",
    "problem_solving_guidance": "Problem Solving Guidance",
    "stress_management": "Stress Management",
    "conflict_resolution": "Conflict Resolution",
    "decision_making_support": "Decision Making Support",
    "risk_mitigation": "Risk Mitigation",

    // Personal Development
    "character_development": "Character Development",
    "habit_formation": "Beneficial Habit Formation",
    "goal_setting_guidance": "Goal Setting Guidance",
    "motivation_factors": "Motivation Factors",
    "confidence_building": "Confidence Building",
    "self_improvement_areas": "Self Improvement Areas",

    // Relationship Year
    "love_life_forecast": "Love Life Forecast",
    "marriage_prospects": "Marriage Prospects",
    "family_harmony": "Family Harmony",
    "friendship_developments": "Friendship Developments",
    "social_connections": "Social Connections",
    "partnership_opportunities": "Partnership Opportunities",

    // Financial Year
    "income_growth_potential": "Income Growth Potential",
    "expenditure_patterns": "Expenditure Patterns",
    "investment_guidance": "Investment Guidance",
    "debt_management": "Debt Management",
    "savings_opportunities": "Savings Opportunities",
    "financial_planning": "Financial Planning",

    // Health Year
    "vitality_levels": "Vitality Levels",
    "health_maintenance": "Health Maintenance",
    "fitness_goals": "Fitness Goals",
    "wellness_practices": "Wellness Practices",
    "preventive_care": "Preventive Care",
    "mental_health_focus": "Mental Health Focus",

    // Career Year
    "professional_growth": "Professional Growth",
    "job_opportunities": "Job Opportunities",
    "skill_enhancement": "Skill Enhancement",
    "leadership_roles": "Leadership Roles",
    "career_transitions": "Career Transitions",
    "recognition_achievements": "Recognition & Achievements",

    // Spiritual Year
    "spiritual_awakening": "Spiritual Awakening",
    "meditation_practices": "Meditation Practices",
    "inner_growth": "Inner Growth",
    "wisdom_development": "Wisdom Development",
    "divine_connections": "Divine Connections",
    "karmic_lessons": "Karmic Lessons",

    // Travel & Adventure
    "travel_opportunities": "Travel Opportunities",
    "adventure_potential": "Adventure Potential",
    "cultural_experiences": "Cultural Experiences",
    "educational_journeys": "Educational Journeys",
    "pilgrimage_possibilities": "Pilgrimage Possibilities",
    "foreign_connections": "Foreign Connections",

    // Learning & Education
    "learning_opportunities": "Learning Opportunities",
    "skill_certifications": "Skill Certifications",
    "knowledge_expansion": "Knowledge Expansion",
    "teaching_possibilities": "Teaching Possibilities",
    "research_projects": "Research Projects",
    "academic_pursuits": "Academic Pursuits",

    // Creative & Artistic
    "creative_projects": "Creative Projects",
    "artistic_expression": "Artistic Expression",
    "innovative_ideas": "Innovative Ideas",
    "creative_collaborations": "Creative Collaborations",
    "artistic_recognition": "Artistic Recognition",
    "creative_income": "Creative Income Potential",

    // Social & Community
    "community_involvement": "Community Involvement",
    "social_influence": "Social Influence",
    "public_recognition": "Public Recognition",
    "group_activities": "Group Activities",
    "social_causes": "Social Causes",
    "humanitarian_work": "Humanitarian Work",

    // Technology & Innovation
    "technological_adaptation": "Technological Adaptation",
    "digital_opportunities": "Digital Opportunities",
    "innovation_potential": "Innovation Potential",
    "online_presence": "Online Presence",
    "tech_skill_development": "Tech Skill Development",
    "digital_transformation": "Digital Transformation"
};
